/**
 * Emulate a full ES2015+ environment (no < Stage 4 proposals).
 */

import 'core-js/stable';
import LazyLoad from "vanilla-lazyload";
let myLazyLoad = new LazyLoad();